'use strict';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/mergeMap';
import {Observable} from 'rxjs/Observable';
import {deleteAssetRequest} from '../../assets/redux/deleteAsset';
import {getDeleteErrorMessage} from '../../core-utilities/react-i18n';
import {epicErrorHandler} from '../../core-utilities/rx-utils';
import {reduxList as formsReduxList} from '../../forms/redux/forms';
import {autoPrioritiesListActions, pinnedPrioritiesListActions} from '../../priorities/actions';
import {assetProjectListActions, projectListActions} from '../../projects/actions';
import {deleteAssetProjectRequest} from '../../projects/redux/deleteAssetProject';
import {deleteProjectRequest} from '../../projects/redux/deleteProject';
import {
  assetRequirementListActions,
  projectRequirementListActions,
  templateRequirementListActions,
} from '../../requirements/actions';
import {assetTaskListActions, projectTaskListActions, templateTaskListActions} from '../../tasks/actions';
import {logger} from './logger';


const deleteActions = [
  deleteAssetRequest.actions.requestError.TYPE,
  formsReduxList.actions.deleteItemError.TYPE,
  deleteAssetProjectRequest.actions.requestError.TYPE,
  deleteProjectRequest.actions.requestError.TYPE,
  autoPrioritiesListActions.deleteItemError.TYPE,
  pinnedPrioritiesListActions.deleteItemError.TYPE,
  assetProjectListActions.deleteItemError.TYPE,
  projectListActions.deleteItemError.TYPE,
  assetRequirementListActions.deleteItemError.TYPE,
  projectRequirementListActions.deleteItemError.TYPE,
  templateRequirementListActions.deleteItemError.TYPE,
  assetTaskListActions.deleteItemError.TYPE,
  projectTaskListActions.deleteItemError.TYPE,
  templateTaskListActions.deleteItemError.TYPE,
];

export const epics = [
  onDeleteErrorEpic,
];

onDeleteErrorEpic.$inject = [
  '$toast',
];

/**
 * Fallback epic to show a generic error message if a deletion fails.
 * @param {ActionsObservable<ReduxAction>} action$
 * @param {Store} store
 * @param dependencies
 */
export function onDeleteErrorEpic(action$, store, dependencies) {
  return action$.ofType(...deleteActions)
    .mergeMap(showDeleteItemErrorMessage)
    .catch(epicErrorHandler(logger, 'onDeleteItem'));

  /**
   * @param {ReduxAction} action
   */
  function showDeleteItemErrorMessage(action) {
    const error = action.payload.err;
    const messageId = getDeleteErrorMessage(error && (error.statusCode || error.status));

    return Observable
      .fromPromise(
        dependencies.$toast.showI18nMessage({
          messageId,
          messageParams: {label: action.payload.label || 'this'},
          type: dependencies.$toast.TOAST_TYPES.error,
        }).catch(() => null)
      )
      .filter(() => false);
  }
}



// WEBPACK FOOTER //
// ./src/js/system/epics/onDeleteEpic.js